import { Injectable } from '@angular/core';
import { ApiClientService } from './api-client.service';
import { UrlService } from './url.service';
import { EmptyRowService } from './empty-row.service';
import { AuthenticationService } from './authentication.service';
import { AmenitiesService } from './amenities.service';
import { ServiceRequestService } from './service-request.service';
import { DocumentsService } from './documents.service';
import { EmailService } from './email.service';
import { PassOnLogService } from './pass-on-log.service';
import { ParcelsService } from './parcels.service';
import { IncidentReportsService } from './incident-reports.service';
import { DailyReportsService } from './daily-reports.service';
import { KeyLogService } from './key-log.service';
import { ParkingPassService } from './parking-pass.service';
import { FrontDeskInstructionsService } from './front-desk-instructions.service';
import { SelectedBuilding } from '../types/data.types';

@Injectable()
export class ResidentServicesService {
    itemsOfServices: any[] = [];
    dictionary = {
        amenity: { name: 'Book an Amenity', id: 1, code: 'amenity', service: this.amenitiesService, showmodal: 'isAmenityModalShow', description: 'Amenities'},
        service_request: { name: 'Service Request', id: 2, code: 'service_request', service: this.serviceRequestService, showmodal: 'isServiceRequestModalShow', description: 'Service Requests'},
        parking_pass: { name: 'Parking Pass', id: 3, code: 'parking_pass', service: this.parkingPassService, showmodal: 'isParkingPassModalShow', description: 'Parking Passes'},
        bldn: { name: 'Building', id: 4, code: 'bldn' },
        documents: { name: 'Documents', id: 5, code: 'documents', service: this.documentsService, showmodal: 'isDocumentViewModalShow' },
        email_merge: { name: 'Email Merge', id: 6, code: 'email_merge', service: this.emailService, showmodal: 'isEmailViewModalShow' },
        pass_on_log: { name: 'Pass on log', id: 7, code: 'pass_on_log', service: this.passOnLogService, showmodal: 'isPassOnLogModalShow' },
        parcels: { name: 'Parcels', id: 8, code: 'parcels', service: this.parcelsService, showmodal: 'isParcelModalShow' },
        inc_report: { name: 'Incident Report', id: 9, code: 'inc_report', service: this.incidentReportsService, showmodal: 'isIncidentReportModalShow' },
        daily_report: { name: 'Daily Report', id: 10, code: 'daily_report', service: this.dailyReportsService, showmodal: 'isDailyReportsModalShow' },
        key_log: { name: 'Key Log', id: 11, code: 'key_log', service: this.keyLogService, showmodal: 'isKeyLogModalShow' },
        front_desk_instructions: { name: 'Front Desk Instructions', id: 12, code: 'front_desk_instructions', service: this.frontDeskInstructionsService, showmodal: 'isFrontDeskInstructionsModalShow', description: 'Front Desk Instructions'}
    };

    constructor(public api: ApiClientService,
        public urlService: UrlService,
        public emptyRowService: EmptyRowService,
        public authenticationService: AuthenticationService,
        private amenitiesService: AmenitiesService,
        private serviceRequestService: ServiceRequestService,
        private documentsService: DocumentsService,
        private emailService: EmailService,
        private passOnLogService: PassOnLogService,
        private parcelsService: ParcelsService,
        private incidentReportsService: IncidentReportsService,
        private dailyReportsService: DailyReportsService,
        private keyLogService: KeyLogService,
        private parkingPassService: ParkingPassService,
        private frontDeskInstructionsService: FrontDeskInstructionsService
    ) {
    }

    updateServices() {
        const selectedBuilding = JSON.parse(localStorage.getItem('residentselectedBuilding')) as SelectedBuilding;

        this.itemsOfServices = [];
        selectedBuilding.rolePermissions.forEach(key => {
            this.itemsOfServices.push(this.dictionary[key]);
        });

        if(selectedBuilding.cNSettings.useResidentInstruction) {
            this.itemsOfServices.push(this.dictionary['front_desk_instructions']);
        }
    }

}



// WEBPACK FOOTER //
// /app/src/app/services/resident-services.service.ts